<span aria-live="polite" aria-atomic="true" class="sr-only" #liveRegion></span>

@if (entry.base?.display) {
  <!-- Houses dynamically updated stringified data-->
  <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath"></form>
  <!-- Houses component specific, parsed data -->
  <form [formGroup]="personsForm">
    <ng-container formArrayName="persons">
      @for (person of persons; track trackByAttr(i, person); let i = $index) {
        <section [formGroupName]="i"
          class="applicant-fields">
          @if (allowRemoval) {
            @switch (persons.length) {
              @case (1) {
                <h3>{{applicantType}} Details (<a href="javascript:void(0)" (click)="removePerson(i)"
                #remove>remove</a>)</h3>
              }
              @default {
                <h3>{{applicantType}} {{entry.custom?.useAlphaIndex ? alphaMap.get(i) : i + 1 }} Details
                  (<a href="javascript:void(0)" (click)="removePerson(i)" #remove>remove</a>)</h3>
                }
              }
            } @else {
              @switch (persons.length) {
                @case (1) {
                  <h3>{{applicantType}} Details</h3>
                }
                @default {
                  <h3>{{applicantType}} {{i + 1}} Details</h3>
                }
              }
            }
            <!-- DATE OF BIRTH-->
            <mat-form-field appearance="outline">
              <mat-label>Date of Birth</mat-label>
              <input matInput placeholder="MM/DD/YYYY" [matDatepicker]="picker" formControlName="dob"/>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView='multi-year'></mat-datepicker>
              <!-- Is there an error at all, and should we show errors at all-->
              <!-- this is the specific error messaging-->
              @if (persons[i].get('dob').errors && (persons[i].get('dob').touched || persons[i].get('dob').dirty)) {
                <mat-error
                  class="cross-validation-error-message alert">
                  @if (persons[i].get('dob').errors.minAgeInvalid) {
                    <span>Minimum Age Not Valid (min: {{entry.custom.minAge}}
                      years)<br></span>
                    }
                    @if (persons[i].get('dob').errors.maxAgeInvalid) {
                      <span>Maximum Age Not Valid (max: {{entry.custom.maxAge}}
                        years)<br></span>
                      }
                      @if (persons[i].get('dob').errors.maxToday) {
                        <span>Date of Birth must not be after today.<br></span>
                      }
                      @if (persons[i].get('dob').errors.required) {
                        <span>You must enter a Date of Birth<br></span>
                      }
                    </mat-error>
                  }
                </mat-form-field>
                <!-- DATE OF BIRTH AGE DISPLAY -->
                @if (isOkToDisplayAgeInfo && isEffectiveDateValid && persons[i].get('dob').value && !persons[i].get('dob').errors) {
                  <div class="age-display">{{dobAsOfTodayByIndex(i)}}</div>
                }
                <!-- GENDER -->
                <div class="space-me">
                  <mat-label>Gender<span
                  [ngStyle]="{'color': (persons[i].get('gender').errors) ? '#a71919' : '#084266'}">*</span></mat-label>
                  <mat-radio-group formControlName="gender" aria-label="Select a Gender">
                    <mat-radio-button value="F">Female</mat-radio-button>
                    <mat-radio-button value="M">Male</mat-radio-button>
                    @if (entry.custom.showGenderOption_other) {
                      <mat-radio-button value="U">Other</mat-radio-button>
                    }
                  </mat-radio-group>
                  @if (persons[i].get('gender').errors && (persons[i].get('gender').touched || persons[i].get('gender').dirty)) {
                    <mat-error
                      class="cross-validation-error-message alert">
                      @if (persons[i].get('gender').errors.required) {
                        <span>You must select a gender</span>
                      }
                    </mat-error>
                  }
                </div>
                <!-- TOBACCO INDICATOR -->
                @if (!hideCheckbox) {
                  <div class="checkbox-container">
                    <mat-checkbox formControlName="tobaccoIndicator">
                      Tobacco Use?
                      <span
                      [matTooltip]="'Regular use is smoking or using any type of tobacco an average of 4 or more times per week (excluding religious or ceremonial use)'"></span>
                    </mat-checkbox>
                  </div>
                }
              </section>
            }
          </ng-container>
        </form>
      }
      <div #templateCustom [hidden]="!entry.base?.display"></div>